<template>
<div>
    <el-table :data="vendedores" style="width: 100%">
        <el-table-column prop="name" label="Nombre" />
        <el-table-column prop="email" label="Email" />
        <el-table-column prop="link" label="Enlace de vendedor">
            <template #default="scope">
                <el-button link type="primary" size="small" @click.prevent="copy(scope.row.link)">
                    {{ scope.row.link }}
                </el-button>
            </template>
        </el-table-column>
        <el-table-column prop="" label="Estado">
            <template #default="scope">
                <el-tag
                    class="ml-2"
                    :type="scope.row.status == 0 ? 'warning' : 'success'"
                    effect="dark"
                    round
                    >{{ scope.row.status == 0 ? 'Inactivo' : 'Activo' }}</el-tag
                >
            </template>
        </el-table-column>
        <el-table-column prop="" label="Acción">
            <template #default="scope">
                <el-button type="primary" size="small" @click.prevent="modalEditar(scope.row)">
                    Editar
                </el-button>
                <el-button type="primary" size="small" @click.prevent="cambiarEstado(scope.row.id)">
                    Cambiar estado
                </el-button>
            </template>
        </el-table-column>
    </el-table>

    <el-dialog v-model="dialogVisible" title="Editar los datos del vendedor" width="50%">
        <div>
            <span>Nombres</span>
            <el-input v-model="this.vendedorSelected.name" placeholder="Ingrese nombre" />
        </div>
        <br>
        <div class="py-2">
            <span>Desea cambiar la Contraseña?</span>
            <el-checkbox v-model="this.cambioContraseña" label="si" size="large" />
        </div>

        <div class="py-2" v-if="this.cambioContraseña == true">
            <span>Contraseña</span>
            <el-input v-model="this.password" placeholder="Ingrese contraseña" />
            <br>

            <span>Confirmar contraseña</span>
            <el-input v-model="this.password_confirm" placeholder="Ingrese contraseña" />
            <br>
        </div>
        <div class="py-2">
            <span>Correo</span>
            <el-input v-model="this.vendedorSelected.email" placeholder="Ingrese correo" />
        </div>
        <br>
        <div class="py-2">
            <span>Teléfono</span>
            <el-input v-model="this.vendedorSelected.phone" placeholder="Ingrese teléfono" />
        </div>
        <br>
        <div class="py-2">
            <span>Tipo de documento</span>
            <br>
            <select v-model="this.vendedorSelected.doc_type_id" id="item">
                <option value="" disabled selected>Seleccione una acción</option>
                <option v-for="item in this.documentos" :value="item.id">{{item.name}}</option>
            </select>
        </div>
        <br>
        <div class="py-2">
            <span>Nro. de documento</span>
            <el-input v-model="this.vendedorSelected.number_doc" placeholder="Ingrese número de documento" />
        </div>
        <br>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancelar</el-button>
                <el-button type="primary" @click="this.submit()">
                    Guardar
                </el-button>
            </span>
        </template>
    </el-dialog>

</div>
</template>

<script>
export default {
    data() {
        return {
            vendedores: [],
            documentos: [],
            vendedorSelected: {},
            dialogVisible: false,
            cambioContraseña: false,
            isSubmitting: false,
            loading: false,
            password: '',
            password_confirm: '',
        };
    },
    methods: {
        listarVendedores() {
            axios.get("/usuarios/vendedores/listar").then((response) => {
                this.vendedores = response.data;
            });
        },

        listarTipoDocumento() {
            axios.get("/document-types").then((response) => {
                this.documentos = response.data;
            });
        },

        modalEditar(vendedor) {
            this.vendedorSelected = vendedor;
            this.cambioContraseña = false;
            this.dialogVisible = true;
        },

        copy(link) {
            let aux = document.createElement('input');
            aux.setAttribute('value', link);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand('copy');
            document.body.removeChild(aux);
            this.$message.success('Enlace copiado');
        },

        async submit() {
            if (this.validateFields()) {
                this.isSubmitting = true;
                const formdata = new FormData();
                formdata.append('id', this.vendedorSelected.id);
                formdata.append('name', this.vendedorSelected.name);
                formdata.append('email', this.vendedorSelected.email);
                formdata.append('phone', this.vendedorSelected.phone);
                formdata.append('doc_type_id', this.vendedorSelected.doc_type_id);
                formdata.append('number_doc', this.vendedorSelected.number_doc);
                if(this.cambioContraseña){
                    formdata.append('password', this.password);
                }

                try {
                    this.loading = true;
                    const request = await axios({
                        url: '/usuarios/vendedores/actualizar',
                        method: 'post',
                        data: formdata,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    });
                    const response =
                        request.status == 200 ?
                        this.$message.success('El Vendedor ha sido actualizado correctamente') :
                        await this.$message.warning('Error al validar elemento');
                    this.isSubmitting = false;
                    this.loading = false;
                    this.password = '';
                    this.password_confirm = '';
                    this.listarVendedores();
                    this.dialogVisible = false;
                } catch (error) {
                    this.isSubmitting = false;
                    this.loading = false;
                    console.log(error);
                }
            }
        },

        async cambiarEstado(id) {
            console.table(this.vendedorSelected);

            this.isSubmitting = true;
            const formdata = new FormData();
            formdata.append('id', id);

            try {
                this.loading = true;
                const request = await axios({
                    url: '/usuarios/vendedores/estado/cambiar',
                    method: 'post',
                    data: formdata,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                });
                const response =
                    request.status == 200 ?
                    this.$message.success('El Vendedor ha sido actualizado correctamente') :
                    await this.$message.warning('Error al validar elemento');
                this.isSubmitting = false;
                this.loading = false;
                this.password = '';
                this.password_confirm = '';
                this.listarVendedores();
                this.dialogVisible = false;
            } catch (error) {
                this.isSubmitting = false;
                this.loading = false;
                console.log(error);
            }
        },

        validateFields() {

            if (!this.vendedorSelected.name || this.vendedorSelected.name.trim() === '' || this.vendedorSelected.name === 0) {
                this.$message.warning('Nombre esta vacio!');
                return false;
            }

            if (this.vendedorSelected.name.length > 50) {
                this.$message.warning('Nombre demasiado largo!');
                return false;
            }
            if(this.cambioContraseña){
                if (this.password != this.password_confirm) {
                    this.$message.warning('Contraseñas no coinciden!');
                    return false;
                }
            }

            if (!this.vendedorSelected.email || this.vendedorSelected.email.trim() === '' || this.vendedorSelected.email === 0) {
                this.$message.warning('Email esta vacio!');
                return false;
            }

            if (this.vendedorSelected.email.length > 50) {
                this.$message.warning('Email demasiado largo!');
                return false;
            }

            if (!this.vendedorSelected.phone || this.vendedorSelected.phone.trim() === '' || this.vendedorSelected.phone === 0) {
                this.$message.warning('Telefono esta vacio!');
                return false;
            }

            if (this.vendedorSelected.phone.length > 50) {
                this.$message.warning('Telefeno demasiado largo!');
                return false;
            }

            if (this.vendedorSelected.doc_type_id == 0) {
                this.$message.warning('Seleccione un tipo de documento!');
                return false;
            }

            if (!this.vendedorSelected.number_doc || this.vendedorSelected.number_doc.trim() === '' || this.vendedorSelected.number_doc === 0) {
                this.$message.warning('Número de documento esta vacio!');
                return false;
            }

            if (this.vendedorSelected.number_doc.length > 50) {
                this.$message.warning('Número de documento es demasiado largo!');
                return false;
            }

            return true;
        },
    },
    mounted() {
        this.listarVendedores();
        this.listarTipoDocumento();
    },
};
</script>
